const clampToNearestTen = (value) => Math.max(0, Math.round(value / 10) * 10);

export const estimatePreSignupAidPotential = ({
  age,
  status,
  housing,
  monthlyIncome,
  familySituation,
  children,
}) => {
  const signals = [];
  let monthlyPotential = 0;
  const income = Number(monthlyIncome) || 0;
  const childCount = Number(children) || 0;
  const userAge = Number(age) || 0;

  if (housing === 'renter' && income <= 1800) {
    signals.push('APL');
    monthlyPotential += income <= 800 ? 180 : income <= 1500 ? 130 : 90;
  }

  if (status === 'student' && income <= 900 && userAge <= 28) {
    signals.push('Bourse/CROUS');
    monthlyPotential += 110;
  }

  if ((status === 'employee' || status === 'freelance') && income > 700 && income <= 1700) {
    signals.push('Prime activite');
    monthlyPotential += income <= 1300 ? 170 : 130;
  }

  if ((familySituation === 'single_parent' || childCount > 0) && income <= 2200) {
    signals.push('Aides famille');
    monthlyPotential += familySituation === 'single_parent' ? 110 : 70;
  }

  if (income <= 900) {
    signals.push('CSS');
    monthlyPotential += 40;
  }

  return {
    monthlyPotential: clampToNearestTen(monthlyPotential),
    signals,
  };
};
